<script>
  import { partyToColour, partyToHoverColour } from '$lib/constants/index';
  let {
    w,
    h,
    margin,
    data,
    xScale,
    yScale,
    activeMediaOutlet,
    hoveredParty,
    trends,
  } = $props();

  let canvas;

  const r = 2;
  // matches the seat threshold that keeps a party's line coloured by default
  const MAJOR_THRESHOLD = 10;

  // only parties whose line is coloured by default (last value >= threshold)
  // get coloured dots by default — the rest light up only on hover
  const lastValue = (party) => {
    const datum = trends && trends[party];
    return datum && datum.length ? datum[datum.length - 1][1] : undefined;
  };

  const isMajorParty = (party) => {
    const datum = trends && trends[party];
    if (!datum || !datum.length) return false;
    return datum[datum.length - 1][1] >= MAJOR_THRESHOLD;
  };

  const draw = (w, hoveredParty) => {
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, w, h);

    ctx.lineWidth = 0.75;
    const baseAlpha = activeMediaOutlet.value === 'all' ? 0.2 : 1;

    data.forEach((d) => {
      if (d.date >= xScale.domain()[0]) {
        const x = margin.left + xScale(d.date);
        const y = margin.top + yScale(d.value);
        const color = partyToColour(d.party);
        const isMajor = isMajorParty(d.party);

        if (hoveredParty) {
          const isHovered = d.party === hoveredParty;
          ctx.strokeStyle = isHovered ? partyToHoverColour(d.party, lastValue(d.party)) : '#eaeaea';
          ctx.globalAlpha = isHovered ? 1 : 0.08;
        } else {
          ctx.strokeStyle = isMajor ? color : '#cccccc';
          ctx.globalAlpha = baseAlpha;
        }
        ctx.beginPath();
        ctx.arc(x, y, r, 0, 2 * Math.PI);
        ctx.stroke();
      }
    });
  };

  $effect(() => {
    if (data && xScale) draw(w, hoveredParty);
  });
</script>

<canvas
  width={w}
  height={h}
  style="width: {w}px; height: {h}px;"
  bind:this={canvas}
></canvas>

<style lang="scss">
</style>
